// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"_loading_loadingIcon_2KEMq","clearfix":"_loading_clearfix_3X9qG"};